export enum KmatType {
  DEFAULT = "066",
  GUIDEWAY = "064",
  CARRIAGE = "065",
  METRIC_SHAFT = "060",
  INCH_SHAFT = "078",
}

const kmatTypes = [KmatType.DEFAULT, KmatType.GUIDEWAY, KmatType.CARRIAGE, KmatType.METRIC_SHAFT, KmatType.INCH_SHAFT];

export function getKmatType(csticKey: string): KmatType {
  return kmatTypes.find((type) => csticKey.endsWith(type)) ?? KmatType.DEFAULT;
}
